import { Helmet } from 'react-helmet'
import { useUser } from 'app/User'
import AlertDialog from 'components/AlertDialog/AlertDialog'
import LoadingButton from 'components/molecules/LoadingButton/LoadingButton'
import PageDisplay from 'components/PageDisplay/PageDisplay'
import { Box } from '@mui/system'
import { Typography } from '@mui/material'
import { useResetUserPasswordMutation } from 'lib/apollo/hooks'

function Profile() {
  const { user } = useUser()

  const [resetUserPassword, { loading, error, data, reset }] =
    useResetUserPasswordMutation()

  const handleResetPassword = () => {
    user?.email &&
      resetUserPassword({
        variables: {
          input: {
            email: user?.email,
            redirectUrl: `${window.location.origin}/home`,
            orgId: user?.orgId,
          },
        },
      })
  }

  return (
    <>
      <Helmet>Profile</Helmet>
      <PageDisplay>
        <Box px={1.5} pt={1.5}>
          <Typography variant="h1">Your Profile</Typography>
          <Box mt={2}>
            <Typography variant="h3" mb={1}>
              Email
            </Typography>
            {user?.email}
          </Box>
          <Box mt={2}>
            <Typography variant="h3" mb={1}>
              First Name
            </Typography>
            {user?.firstName}
          </Box>
          <Box mt={2}>
            <Typography variant="h3" mb={1}>
              Last Name
            </Typography>
            {user?.lastName}
          </Box>
          <Box mt={2}>
            <Typography variant="h3" mb={1}>
              Mobile Number
            </Typography>
            {user?.mobileNumber}
          </Box>

          <Box mt={4}>
            <Typography variant="h1">Reset password</Typography>
            <Typography>
              To reset your password click "Reset Password". An email will be
              sent to you with a link that will guide you through choosing a new
              password.
            </Typography>
            <LoadingButton
              disabled={data?.resetUserPassword.success}
              loading={loading}
              loadingText="Resetting password"
              variant="contained"
              onClick={handleResetPassword}
              mode={data?.resetUserPassword.success ? 'success' : 'default'}
              sx={{ my: 3 }}
            >
              {data?.resetUserPassword.success
                ? 'Reset email sent!'
                : 'Reset password'}
            </LoadingButton>
            <AlertDialog
              isOpen={!!error}
              description={'There was an error resetting your password.'}
              position={{ bottom: '1.5em' }}
              primaryButtonAction={handleResetPassword}
              secondaryButtonAction={reset}
              isPrimaryDisabled={false}
              isPrimaryLoading={loading}
            />
          </Box>
        </Box>
      </PageDisplay>
    </>
  )
}

export default Profile
